module.exports = __webpack_public_path__ + "static/media/8-cubes-h.c5cdc708.png";